import {
  SET_Liablity_INFORMATION,
  SET_SELECTED_Liablity_INFORMATION,
  SET_Liablity_ENTITY_INFORMATION,
  SET_Liablity_TYPE_INFORMATION,
  GET_CLIENT_INFORMATION,
  SET_ICE_API_RESPONSE,
  SET_LOAN_CHART_MODEL,
  SET_COMPARE_LOAN_INFO,
  SET_ICE_PROJECTION_MODEL,
} from "../../../helpers/vuex-constants";
import { LoanService } from "../../../services";
import Loan from "../../../models/loan";

export default {
  setLiablityInformation: {
    root: true,
    async handler(context, payload) {
      try {
        const response = await LoanService.getLiablityInformation(payload);
        const clientinfo = await context.rootGetters[GET_CLIENT_INFORMATION];
        const apidata = response.data;
        if (response.status == 200 && apidata.length >= 1) {
          context.commit(
            SET_Liablity_INFORMATION,
            Loan.setLoanInformation(apidata, clientinfo)
          );
        } else {
          context.commit(SET_Liablity_INFORMATION, Loan.setLoanInformation([]));
        }
        context.commit(
          SET_Liablity_ENTITY_INFORMATION,
          Loan.setLoanEntiyInformation(clientinfo)
        );
        context.commit(
          SET_Liablity_TYPE_INFORMATION,
          Loan.setLoanTypeInformation(apidata)
        );
      } catch (error) {
        console.log(error);
      }
    },
  },

  async setSelectedLiablityInformation(context, payload) {
    context.commit(SET_SELECTED_Liablity_INFORMATION, payload);
  },

  async setAllLiablityInformation(context, payload) {
    context.commit(SET_Liablity_INFORMATION, payload);
  },

  async setIceProjectionModel(context, payload) {
    context.commit(SET_ICE_PROJECTION_MODEL, payload);
  },
  async setIceApiResponse(context, payload) {
    context.commit(SET_ICE_API_RESPONSE, payload);
  },
  async setLiablityDefaultModel(context, payload) {
    context.commit(SET_Liablity_INFORMATION, payload);
    context.commit(
      SET_Liablity_ENTITY_INFORMATION,
      Loan.setLoanEntiyInformation(context.rootGetters[GET_CLIENT_INFORMATION])
    );
    context.commit(
      SET_Liablity_TYPE_INFORMATION,
      Loan.setLoanTypeInformation([])
    );
  },

  async setCompareLoanInfo(context, payload) {
    context.commit(SET_COMPARE_LOAN_INFO, payload);
  },

  async setloanChartModel(context, payload) {
    context.commit(SET_LOAN_CHART_MODEL, payload);
  },
};
